import { Injectable } from "@angular/core";
import {
  HttpClient,
  HttpHeaders,
  HttpErrorResponse,
} from "@angular/common/http";
import { Licitacao } from "../_classes/licitacao";
import { Observable } from "rxjs/Observable";
import { Arquivo } from "../_classes/arquivo";

import { URL } from "../_mocks/url";

import "rxjs/add/operator/map";
import "rxjs/add/operator/catch";
import { stringFormatter } from "../util/stringFormatter";
import { DadosPaginacao } from "../components/paginacao/dadosPaginacao";
import { LicitacaoFilter } from "../_classes/licitacaoFilter";

const httpOptionsSemAutenticacao = {
  headers: new HttpHeaders({ "Content-Type": "application/json" }),
};

const httpOptionsComAutenticacao = () => {
  return {
    headers: new HttpHeaders({
      "Content-Type": "application/json",
      Authorization: localStorage.getItem("access_token"),
    }),
  };
};

@Injectable()
export class LicitacaoService {
  private urlLicitacao = URL + "licitacao";

  constructor(private http: HttpClient) {}

  //prepara a licitacao para ser salva/editada
  private prepararLicitacao(licitacao: Licitacao): Licitacao {
    const licitacaoFinal = JSON.parse(JSON.stringify(licitacao));

    licitacaoFinal.dataDeCadastro = this.formatarToLocalDate(
      licitacaoFinal.dataDeCadastro
    );
    licitacaoFinal.dataDeRealizacao = this.formatarToLocalDate(
      licitacaoFinal.dataDeRealizacao
    );
    licitacaoFinal.arquivos.forEach((arquivo) => {
      arquivo.vigenciaInicio = this.formatarToLocalDate(arquivo.vigenciaInicio);
      arquivo.vigenciaFim = this.formatarToLocalDate(arquivo.vigenciaFim);
      arquivo.dataPublicacao = this.formatarToLocalDate(arquivo.dataPublicacao);
    });

    if (licitacaoFinal.valorLicitacao) {
      licitacaoFinal.valorLicitacao = licitacao.valorLicitacao.replace(
        /[a-zA-Z $]/g,
        ""
      );
    }

    if (licitacao.valorEstimadoLicitacao) {
      licitacaoFinal.valorEstimadoLicitacao = licitacao.valorEstimadoLicitacao.replace(
        /[a-zA-Z $]/g,
        ""
      );
    }

    if (licitacaoFinal.arquivos) {
      licitacaoFinal.arquivos.forEach((arqivo: Arquivo) => {
        if (arqivo.identificador) {
          arqivo.identificador = stringFormatter.toOnlyPositiveTruncatedNumberString(
            arqivo.identificador
          );
        }
        if (arqivo.primeiroAditivo) {
          arqivo.primeiroAditivo = arqivo.primeiroAditivo.replace(
            /[a-zA-Z $]/g,
            ""
          );
        }
        if (arqivo.segundoAditivo) {
          arqivo.segundoAditivo = arqivo.segundoAditivo.replace(
            /[a-zA-Z $]/g,
            ""
          );
        }
        if (arqivo.valorContrato) {
          arqivo.valorContrato = arqivo.valorContrato.replace(
            /[a-zA-Z $]/g,
            ""
          );
        }
      });
    }

    console.log("[LicitacoesComponent] LicitacaoService...", licitacaoFinal);
    return licitacaoFinal;
  }

  saveLicitacao(licitacao: Licitacao): Observable<Licitacao> {
    return this.http.post<Licitacao>(
      this.urlLicitacao,
      this.prepararLicitacao(licitacao),
      httpOptionsComAutenticacao()
    );
  }

  uploadFile(id, arquivo: Arquivo) {
    const arquivoFinal = JSON.parse(JSON.stringify(arquivo));

    if (arquivoFinal.identificador) {
      arquivoFinal.identificador = stringFormatter.toOnlyPositiveTruncatedNumberString(
        arquivoFinal.identificador
      );
    }
    if (arquivoFinal.primeiroAditivo) {
      arquivoFinal.primeiroAditivo = arquivoFinal.primeiroAditivo.replace(
        /[a-zA-Z $]/g,
        ""
      );
    }
    if (arquivoFinal.segundoAditivo) {
      arquivoFinal.segundoAditivo = arquivoFinal.segundoAditivo.replace(
        /[a-zA-Z $]/g,
        ""
      );
    }

    const urlFinal = this.urlLicitacao + "/" + `${id}` + "/upload";
    return this.http.put<any>(
      urlFinal,
      arquivoFinal,
      httpOptionsComAutenticacao()
    );
  }

  getLicitacoes(): Observable<Licitacao[]> {
    return this.http.get<Licitacao[]>(
      this.urlLicitacao,
      httpOptionsSemAutenticacao
    );
  }

  getLicitacaoById(id: number): Observable<Licitacao> {
    const urlFinal = this.urlLicitacao + "/" + `${id}`;
    return this.http
      .get<Licitacao>(urlFinal, httpOptionsSemAutenticacao)
      .map((licitacao: any) => {
        licitacao.dataDeCadastro = this.ptBrDateToDateObject(
          licitacao.dataDeCadastro
        );
        licitacao.dataDeRealizacao = this.ptBrDateToDateObject(
          licitacao.dataDeRealizacao
        );

        licitacao.arquivos.forEach((arquivo) => {
          arquivo.vigenciaInicio = this.ptBrDateToDateObject(
            arquivo.vigenciaInicio
          );
          arquivo.vigenciaFim = this.ptBrDateToDateObject(arquivo.vigenciaFim);
          arquivo.dataPublicacao = this.ptBrDateToDateObject(
            arquivo.dataPublicacao
          );
        });

        return licitacao;
      });
  }

  editLicitacao(id: number, licitacao: Licitacao): Observable<Licitacao> {
    const urlFinal = this.urlLicitacao + "/" + `${id}`;
    return this.http.put<Licitacao>(
      urlFinal,
      this.prepararLicitacao(licitacao),
      httpOptionsComAutenticacao()
    );
  }

  deleteLicitacao(id: number) {
    const urlFinal = this.urlLicitacao + "/" + `${id}`;
    return this.http.delete<any>(urlFinal, httpOptionsComAutenticacao());
  }

  getLicitacoesByPage(): Observable<Licitacao[]> {
    const urlFinal = this.urlLicitacao + "/limit";
    return this.http.get<Licitacao[]>(urlFinal, httpOptionsSemAutenticacao);
  }

  getArquivosDaLicitacao(id: number): Observable<Arquivo[]> {
    const urlFinal = this.urlLicitacao + `/${id}/load/files`;
    return this.http.get<Arquivo[]>(urlFinal, httpOptionsSemAutenticacao);
  }

  prepareLicitacaoFilter(filter: LicitacaoFilter): LicitacaoFilter {
    const filterToSend: any = { ...filter };

    if (filterToSend.dataInicio)
      filterToSend.dataInicio = this.formatarToLocalDate(
        filter.dataInicio.toString()
      );
    if (filterToSend.dataFim)
      filterToSend.dataFim = this.formatarToLocalDate(
        filter.dataFim.toString()
      );

    return filterToSend;
  }

  getLicitacoesByFilter(
    filter: LicitacaoFilter,
    dadosPaginacao?: DadosPaginacao
  ): Observable<Licitacao[]> {
    const urlFinal = this.urlLicitacao + "/filter";
    const filterToSend = this.prepareLicitacaoFilter(filter);

    const paginationQueryParams = this.dadosPaginacaoToQueryParam(
      dadosPaginacao
    );

    return this.http.post<Licitacao[]>(urlFinal, filterToSend, {
      params: paginationQueryParams,
    });
  }

  private dadosPaginacaoToQueryParam(
    dadosPaginacao: DadosPaginacao
  ): { [key: string]: string } {
    if (!dadosPaginacao) {
      return {};
    }

    const paginacaoQueryParam = {};

    if (dadosPaginacao) {
      paginacaoQueryParam["page"] = dadosPaginacao.page;
      paginacaoQueryParam["size"] = dadosPaginacao.size;
    }

    return paginacaoQueryParam;
  }

  jsonToQueryString(json) {
    const queryString = Object.keys(json)
      .map((key) => {
        if (json[key] == undefined || json[key] == null) {
          return "";
        }

        return encodeURIComponent(key) + "=" + encodeURIComponent(json[key]);
      })
      .join("&");

    return queryString;
  }

  getTotalEntidades(licitacaoFilter: LicitacaoFilter): Observable<number> {
    const filterToSend = this.prepareLicitacaoFilter(licitacaoFilter);
    return this.http.post<number>(
      `${this.urlLicitacao}/total-registros`,
      filterToSend,
      httpOptionsSemAutenticacao
    );
  }

  getExportarURI(
    tipoExportacao: string,
    filtro: LicitacaoFilter,
    ultimoDadoPaginacao: DadosPaginacao
  ) {
    const filterToSend = this.prepareLicitacaoFilter(filtro);
    const filterQueryParam = this.jsonToQueryString(filterToSend);

    const paginacaoQueryParam = this.jsonToQueryString(ultimoDadoPaginacao);

    const queryParams = `${filterQueryParam}&${paginacaoQueryParam}`;
    const recurso = `${this.urlLicitacao}/exportar/${tipoExportacao}?${queryParams}`;
    return recurso;
  }

  formatarToLocalDate(dateStringToFormat: string) {
    if (!dateStringToFormat) return;
    const dateToFormat = new Date(dateStringToFormat);
    return dateToFormat.toLocaleDateString("pt-BR").split(" ")[0];
  }

  formatarToLocalDateTime(dateStringToFormat: Date) {
    if (!dateStringToFormat) return;
    const dateToFormat = new Date(dateStringToFormat);
    return `${dateToFormat.getDay()}/${dateToFormat.getMonth()}/${dateToFormat.getFullYear()} ${dateToFormat.getHours()}:${dateToFormat.getMinutes()}:${dateToFormat.getSeconds()}`;
  }

  /**
   * convert a dd/MM/YYYY to a date Object
   */
  ptBrDateToDateObject(dateString: string) {
    if (!dateString || dateString.length === 0) return dateString;
    const date = new Date(
      dateString.replace(/(\d{2})\/(\d{2})\/(\d{4})/, "$2/$1/$3")
    );
    return date;
  }

  generateLicitacaoPermanentLink(baseURL: String, licitacao: Licitacao) {
    const url = `${baseURL}/licitacoes/${licitacao.modalidade}/${licitacao.numeroDaLicitacao}/${licitacao.orgao}`;
    return url;
  }

}



// WEBPACK FOOTER //
// ./src/app/services/licitacao.service.ts